
export const GEO_MUTATION_SET_GEO_DEFAULT = 'geo_mutation_set_geo_default'
export const GEO_MUTATION_SET_GEO_STORED = 'geo_mutation_set_geo_stored'

export const GEO_ACTION_REQUEST_USER_IP = 'geo_action_request_user_ip'
export const GEO_ACTION_REQUEST_CITY_BY_IP = 'geo_action_request_city_by_ip'

export const GEO_GETTER_GET_COORDS = 'geo_getter_get_coords'
export const GEO_GETTER_GET_CITY = 'geo_getter_get_city'
